document.addEventListener("DOMContentLoaded", function() {
    const dropdowns = document.querySelectorAll(".js-menu-content");
    const btnMore = document.querySelectorAll(".js-menu");

    dropdowns.forEach(function(dropdown) {
        dropdown.style.maxHeight = "0";
        dropdown.style.overflow = "hidden";
        dropdown.style.transition = "max-height 0.5s ease";
    });

    btnMore.forEach(function(button) {
        button.addEventListener("click", function() {
            const trigger = button.closest('.kitaden-bar').querySelector('.js-menu-content');
            if (trigger.style.maxHeight === "0px" || trigger.style.maxHeight === "") {
                trigger.style.maxHeight = trigger.scrollHeight + "px";
            } else {
                trigger.style.maxHeight = "0";
            }
            button.classList.toggle("close");
        });
    });
});
